import {Injectable} from '@angular/core';
import {ModelProvider} from "../../../framework/providers/modelProvider/ModelProvider";
import {BusinessService} from "../../../core/services/BusinessService";
import {ModelToolsProvider} from "../../../framework/providers/model-tools/model-tools";
import {Events} from "../../../framework/providers/events";
import {AlertController} from "@ionic/angular";
import {AppDataService} from "../../../core/services/AppDataService";
import {CatalogMenuComponent} from "../pages/catalog-admin/components/catalog-menu/catalog-menu.component";
import {AdminService} from "./AdminService";
import {TranslateService} from "@ngx-translate/core";

@Injectable({providedIn: 'root'})
export class CatalogAdminService {
    topData = {};
    public noSectionItem = [];
    public topSections = [];
    public items = {};
    public sections = {};
    public filters = {};
    public extra_post_data = {};

    constructor(private modelProvider: ModelProvider, public businessService: BusinessService,
                public adminService: AdminService,
                public translate: TranslateService,
                public modelTools: ModelToolsProvider, public appDataService: AppDataService,
                public events: Events, public alertCtrl: AlertController) {
        let me = this;
        if (this.appDataService.appdata && this.appDataService.appdata.sections) {
            this.start();
        } else {
            this.events.subscribe('appDataSets', function () {
                me.start();
            });
        }
    }

    start() {
        this.items = this.appDataService.appdata['items'];
        this.sections = this.appDataService.appdata['sections'];

        this.fixSectionsData();
    }

    loadNoneSectionItems() {
        let noSectionItem = [];
        for (let itemKey in this.items) {
            if (this.items[Number(itemKey)]['item_sections'].length == 0) {
                noSectionItem.push(Number(itemKey));
            }
        }
        return noSectionItem
    }

    reload1() {
        this.items = this.appDataService.appdata['items'];
        this.sections = this.appDataService.appdata['sections'];
    }

    reload() {
        this.items = this.appDataService.appdata['items'];
        this.sections = this.appDataService.appdata['sections'];
        return this.appDataService.getAppData();
    }

    //type=item //type=section
    clearMark() {
        for (let key in this.items) {
            this.items[key]['marked'] = false;
            this.items[key]['checked'] = false;
        }
        //there is diffrenece how sections in appdata. with .data
        for (let key in this.sections) {
            if (this.sections[key].data['marked']) {
                this.sections[key].data['marked'] = false;
                this.sections[key].data['checked'] = false;
            }
        }

        this.topData['item_marked'] = {}
        this.topData['section_marked'] = {}
        this.topData['item_marked_count'] = 0;
        this.topData['section_marked_count'] = 0;
        this.events.publish('update_sections_appdata'); //update menu nav
    }

    //type=item
    //type=section
    markAll(sectionId) {
        let filters = {'sectionId': sectionId, "skipSubs": false}
        let res = this.getSectionItems(filters);
        for (let item of res['direct_models']) {
            this.markItem('item', item);
        }
    }

    openModel(ev: MouseEvent, model, isItem = false) {
        const fakeEvent = {
            target: {
                getBoundingClientRect: () => ({
                    top: ev.clientY,
                    left: ev.clientX,
                    bottom: ev.clientY,
                    right: ev.clientX,
                    width: 0,
                    height: 0
                })
            }
        };

        this.modelTools.popover(CatalogMenuComponent, {
            event: fakeEvent,
            isItem: isItem,
            showBackdrop: false,
            model: model
        }, 'animated-popover custom-popover2');
    }

    //type=item
    //type=section
    markItem(type, model) {
        // model.data['marked'] = !!!model.data['marked'];
        model.data['checked'] = !!!model.data['checked'];
        model.data['marked'] = !!!model.data['marked'];

        if (!this.topData[type + '_marked']) this.topData[type + '_marked'] = [];
        this.topData[type + '_marked'][parseInt(model.data.id)] = model.data['marked'];
        let x = 0;
        for (let k in this.topData[type + '_marked']) {
            if (this.topData[type + '_marked'][k]) x++;
        }
        this.topData[type + '_marked_count'] = x
    }

    markUpdated(section) {
        section.data['sections'] = section.data['sections'] ? section.data['sections'] : [];
        section.data['updated'] = true;
    }

    //move section to here.
    moveSectionUp(section) {
        section.data['updated'] = true;
        section.data['sectionId'] = null;
        this.fixSectionsData();
    }

    hideSection(sec) {
        let me = this;
        this.modelTools.yesOrNoAlert(function () {
            me.goHideSection(sec);
        }, {'title': this.modelTools.getTranslate('delete'), 'message': this.modelTools.getTranslate('areYouSure')});
    }

    goHideSection(sec) {
        let sections = this.sections;
        let items = this.items;
        // if (!section.data.sectionId) return;
        let section = this.sections[sec.data.id];
        section.data['removed'] = true;
        section.data['hide'] = true;
        section.data['updated'] = true;
        section.data['active'] = false;
        section.data['includeInMenu'] = false;

        if (section.data.sectionId) {
            let topSection = this.sections[section.data.sectionId];
            if (topSection) {
                const index = topSection['sections'].indexOf(section.data.id);
                if (index != -1) topSection['sections'].splice(index, 1);
            }
        }
        const topindex = this.topSections.indexOf(section.data.id.toString());
        if (topindex != -1) {
            this.topSections.splice(topindex, 1);
        }

        this.filters['removeMarkRows'] = 'section';
        if (!this.extra_post_data['section_markedRow']) this.extra_post_data['section_markedRow'] = []
        this.extra_post_data['section_markedRow'].push(sec.data.id);

        //remove from top.
        // if (!section.data.sectionId) {
        section.data.active = false;
        section.data.includeInMenu = false;

        //    total remove? move children one up.
        // for (let i in section['sections']) {
        //     let secId = sections[section['sections'][i]];
        //     secId.data.sectionId = null;
        // }
        // }
        section.data['sectionId'] = -1;
        this.fixSectionsData();
        // section.data.sectionId = null;
        // let sonItems = JSON.parse(JSON.stringify(section['items']));
        // for (let i in sonItems) {
        //     let itemId = sonItems[i];
        //     this.removeItemFromSection(items[itemId], section.data.id);
        // }

    }

    public fixSectionsData() {
        // let items = this.items;
        let sections = this.sections;
        let user_sections = this.appDataService.getPricesListKey('user_sections');
        ////console.log('GET SECTIONS', user_sections, secssarr)
        let topSections = [];
        for (let secId in sections) {
            let sec_data = sections[secId];
            if (!sec_data.data.id) continue;

            if (!sec_data.data.sectionId && !sec_data.data.removed) {
                topSections.push(secId);
            }

            if (!sec_data.pref)
                sec_data.pref = "selectTablePrefixrowClickEvent" + Math.floor(Math.random() * Math.floor(1000000));

            let item_ids = this.loadRecSectionItems(secId);
            sec_data.data['rec_items'] = item_ids;//collect on .data.
            // sec_data.data['items'] = item_ids;//collect on .data.
            // sec_data.data['sections_count'] = item_ids;//collect on .data.
            if (sec_data['sections']) {
                sec_data.data['sections_count'] = sec_data['sections'].length;//collect on .data.
            } else {
                sec_data.data['sections_count'] = 0;
            }
            // let sub_items_count = sec_data.data['items_count'];
            // for (let sec_id of sec_data['sections']) {
            //     sub_items_count += sections[sec_id].data['items_count'];
            // }
            sec_data.data['my_items_count'] = Object.keys(item_ids).length;

        }

        let loadNoneSectionItems = this.loadNoneSectionItems();
        let loadNoneSectionItemslen = loadNoneSectionItems.length;
        //no section item!!
        this.sections[999919999] = {
            'data': {
                "id": '999919999', "images": [], "mainImageUrl": "", "sectionId": null, 'name': 'No Section Items',
                "description": null, "active": true, "includeInMenu": true, "my_items_count": loadNoneSectionItemslen,
                "rec_items": loadNoneSectionItems, "items_count": loadNoneSectionItemslen, "sections_count": 0,
            }, "items": loadNoneSectionItems, "sections": [], "direct_items": loadNoneSectionItems
        };
        if (!topSections.includes('999919999')) topSections.push('999919999');

        let allSectionItems = Object.keys(this.items);
        let allSectionItemslen = allSectionItems.length;
        //no section item!!
        this.sections[999929999] = {
            'data': {
                "id": '999929999', "images": [], "mainImageUrl": "", "sectionId": null, 'name': 'All Items',
                "description": null, "active": true, "includeInMenu": true, "my_items_count": allSectionItemslen,
                "rec_items": allSectionItems, "items_count": allSectionItemslen, "sections_count": 0,
            }, "items": allSectionItems, "sections": [], "direct_items": allSectionItems
        };
        if (!topSections.includes('999929999')) topSections.push('999929999');

        this.topSections = topSections;
        this.topData['topSections'] = topSections;
        this.events.publish('catalog_refresh');
    }

    refresh() {
        this.reload1();
        this.fixSectionsData();
    }

    //move section to here.
    moveMarkedSectionToSection(sectionModel) {
        let sections = this.sections;
        let sectionId = sectionModel.data.id;
        let section = sections[sectionId];
        let sectionsMarked = this.topData['section_marked'];
        console.log('sec marked: ', sectionsMarked);

        for (let mark_sec_id in sectionsMarked) {
            if (parseInt(mark_sec_id) == sectionId) {
                continue;
            }
            if (!mark_sec_id) continue
            if (!sectionsMarked[mark_sec_id]) {
                continue;
            }
            if (mark_sec_id == sectionId) return

            section['updated'] = true;

            // this.markItem('section', this.sections[mark_sec_id]);
            let new_son = this.sections[mark_sec_id];
            // this.appDataService.markItem('section', this.appDataService.sections[mark_sec_id]);
            //remove from initial parent.
            if (new_son.data.sectionId) {
                const index = this.sections[new_son.data.sectionId]['sections'].indexOf(sectionId);
                if (index != -1) this.sections[new_son.data.sectionId]['sections'].splice(index, 1);
            }
            //remove from tops.
            const topindex = this.topData['topSections'].indexOf(mark_sec_id);
            if (topindex != -1) {
                this.topData['topSections'].splice(topindex, 1);
            }

            new_son.data['updated'] = true;
            new_son.data['sectionId'] = sectionId;

            //add to new parent.
            // this.sections[sectionId]['sections'].push(parseInt(mark_sec_id));
            section['sections'].push(parseInt(mark_sec_id));
        }
        this.events.publish('update_sections_appdata'); //update menu nav
        this.clearMark();
        this.fixSectionsData();
        // this.adminService.saveModels([], 'itemToSection', {}, rows, null,
        //        false, [], {});
    }

    addSection(topSec, subSections, id = null) {
        let section = this.appDataService.getSection({
            "id": id ? id : 999999 + Math.floor(Math.random() * Math.floor(1000000)),
            // "extSectionId": id ? id : 999999 + Math.floor(Math.random() * Math.floor(1000000)),
            "name": "חדש",
            "images": [],
            "advs": [],
            "sectionId": null,
            "topSectionName": null,
            "description": null,
            "appStyle": true,
            "is_kit": false,
            "settings": {},
            "includeInMenu": true,
            "items": 0,
            "shippingSection": false,
            "saledata": null,
            "sections_count": 0,
            "updated": true
        });
        section['items'] = [];
        section['sections'] = [];

        let section_data = {
            "id": {value: null, name: "sectionId", edited: true, type: "selectTable"},
            "name": {value: 'חדש', name: "sectionId", edited: true, type: "text"},
            "sectionId": {value: section.data.sectionId, name: "sectionId", edited: true, type: "selectTable"},
            "main": {value: -1, updated: true, name: "", type: "none"}
        };
        this.adminService.saveModel(section_data, 'section', {}).subscribe((data) => {
            section.data.id = data['data']['models'][0]['id'].value

            this.sections[section.data.id] = section;
            if (topSec) {
                section.data.sectionId = topSec.data.id;
                this.sections[section.data.sectionId]['sections'].push(section.data.id);
            } else {
                this.topData['topSections'].unshift(section.data.id);
            }
            subSections.push(section)//add to app data
            this.events.publish('refresh_section_' + (section.data.sectionId ? section.data.sectionId : ''));
        })
        return section;
    }

    addMarkedItemToSection(sectionId, moveItem = false) {
        let items = this.items;
        let itemsMarked = this.topData['item_marked'];
        console.log('items marked: ', itemsMarked);

        for (let item_id in itemsMarked) {
            if (!itemsMarked[item_id]) continue;

            if (items[item_id].sectionId == sectionId) continue

            this.copyItemToSection(item_id, sectionId, moveItem)

            //move sons of the item to the selected section.
            // for (let sonId of items[item_id]['item_sons']) {
            //     this.copyItemToSection(sonId, sectionId, moveItem);
            // }
        }

        this.fixSectionsData();
        // this.adminService.saveModels([], 'itemToSection', {}, rows, null,
        //        false, [], {});
    }

    removeMarkedItemsFromSection(original_section_id) {
        let me = this;
        this.modelTools.yesOrNoAlert(function () {
            me.removeMarkedItemsFromSectionGo(original_section_id);
        }, {'title': this.modelTools.getTranslate('delete'), 'message': this.modelTools.getTranslate('areYouSure')});
    }

    removeMarkedItemsFromSectionGo(original_section_id) {
        let items = this.items;
        let itemsMarked = this.topData['item_marked'];
        console.log('items marked: ', itemsMarked);

        for (let item_id in itemsMarked) {
            this.removeItemFromSectionGo(items[item_id], original_section_id)
        }
    }

    removeItemFromSection(item, original_section_id) {
        let me = this;
        this.modelTools.yesOrNoAlert(function () {
            me.removeItemFromSectionGo(item, original_section_id);
        }, {'title': this.modelTools.getTranslate('delete'), 'message': this.modelTools.getTranslate('areYouSure')});
    }

    removeItemFromSectionGo(item, original_section_id) {
        // if no sections left in item.
        // this.copyItemToSection(item_id, 'rest_items', true);
// for (let secId in item['item_sections']) {
        let items = this.items;

        let i = item['item_sections'].indexOf(original_section_id);
        if (i != -1) item['item_sections'].splice(i, 1);

        item['updated'] = true;

        if (this.sections[original_section_id]) {
            const index = this.sections[original_section_id]['items'].indexOf(parseInt(item.id));
            const index1 = this.sections[original_section_id]['direct_items'].indexOf(parseInt(item.id));
            if (index != -1) {
                this.sections[original_section_id]['items'].splice(index, 1);
            }
            if (index1 != -1) {
                this.sections[original_section_id]['direct_items'].splice(index1, 1);
            }
            this.events.publish('refresh_section_' + original_section_id);
            // this.sections[original_section_id].data['updated'] = true;
        }

        //remove sons of item.
        // let sons = JSON.parse(JSON.stringify(item['item_sons']));
        // for (let sonId of sons) {
        //     this.removeItemFromSection(items[sonId], original_section_id);
        // }

        if (!item['item_sections_mark']) item['item_sections_mark'] = {};
        let relationId = item['item_sections_data'][original_section_id];
        item['item_sections_mark'][relationId] = {'sectionId': original_section_id, 'active': false};

        this.fixSectionsData();
    }

    copyItemToSection(item_id, sectionId, moveItem, original_section_id = null) {
        let item = this.appDataService.getItemModel(item_id);//this.appDataService.items[item_id];

        if (original_section_id && original_section_id == sectionId) return;

        item['updated'] = new Date();
        item.data['updated'] = true;

        let section = this.sections[sectionId];

        // this.markItem('item', item);
        // let item = this.appDataService.items[];
        if (!section['items']) {
            section['items'] = [];
        }
        if (!section['direct_items']) {
            section['direct_items'] = [];
        }

        if (!original_section_id) {
            original_section_id = item.data.sectionData ? item.data.sectionData.id : null;
        }
        // if (original_section_id == sectionId) return

        // already exists?
        if (section['items'].indexOf(parseInt(item.data.id)) == -1) {
            section['items'].unshift(parseInt(item.data.id));
        }
        if (section['direct_items'].indexOf(parseInt(item.data.id)) == -1) {
            section['direct_items'].unshift(parseInt(item.data.id));
        }
        if (item.data['item_sections'].indexOf(parseInt(sectionId)) == -1) {
            item.data['item_sections'].push(sectionId);
        }
        item.data['item_sections_count'] = Object.keys(item.data['item_sections']).length;

        //item to section
        if (!item.data['item_sections_mark']) item.data['item_sections_mark'] = {};
        let relationId = item.data['item_sections_data'][sectionId]; //back row.
        if (!relationId) relationId = 999999 + Math.floor(Math.random() * Math.floor(100000)); //new row.
        item.data['item_sections_mark'][relationId] = {
            'extSectionId': section.data.extSectionId,
            'sectionId': sectionId, 'active': true
        };

        section.data['items_count'] = Object.keys(section['items']).length;

        if (moveItem) {
            // if (original_section_id) {
            let section_ids = JSON.parse(JSON.stringify(item.data['item_sections']));
            for (let i in section_ids) {
                if (sectionId == section_ids[i]) continue
                this.removeItemFromSection(item.data, section_ids[i]);
            }
        }
        //remove from "all items section" sections
        // if (sectionId != 'rest_items') {
        //     let restSectionIndex = this.sections['rest_items']['items'].indexOf(parseInt(item_id));
        //     if (restSectionIndex != -1) {
        //         this.sections['rest_items']['items'].splice(restSectionIndex, 1);
        //     }
        // }
    }

    getSectionItems(filters, rec = true) {
        // ////console.logfilters)
        let sectionId = filters['sectionId'];
        let section = this.sections[sectionId];

        let res = {'models': [], 'modelsCount': 0};
        if (!section) return res;
        // let sections = this.sections;
        // for (let k in sections) {
        //     if (k == sectionId) {
        // ////console.logk, sections[k]['items']);
        // ////console.logk, sections);
        filters['skipSubs'] = filters['skipSubs'] !== false ? true : false;
        // if(!filters['skipped'])
        //     filters['skipped'] = 0;
        // filters['offset']+=filters['skipped'];
        //get son items.
        // let itemIds = this.loadRecSectionItems(sectionId);
        // this.sections[sectionId].data.items = itemIds.length;
        let itemsres = this.appDataService.getItems(section.data['rec_items'], filters)
        // filters['skipped']+=itemsres['skipped'];
        // ////console.logsectionId, sections[k]['items'], itemsres)
        res['models'] = itemsres['res'];
        res['direct_models'] = this.appDataService.getItems(section['direct_items'], filters)?.res

        if (!filters['skipped']) filters['skipped'] = 0;
        filters['skipped'] += itemsres['skipped'];
        res['modelsCount'] = section.data['my_items_count'] - filters['skipped'];
        // ////console.log("SEC ITEMS LENGTH", sections[k]['items'].length, res['modelsCount'], 'skip-', itemsres['skipped'], filters['skipped'])

        return res
        // }
        // }
        // return res;
    }

    loadRecSectionItems(secId, index = 0) {
        index += 1;
        if (index > 7) return;

        let sections = this.sections;

        let itemIds = JSON.parse(JSON.stringify(sections[secId]['items']));

        if (!sections[secId]['sections']) return itemIds;

        for (let sonSecId of sections[secId]['sections']) {
            itemIds = itemIds.concat(this.loadRecSectionItems(sonSecId, index));
        }
        const uniqueSorted = [...new Set(itemIds)];//.sort((a, b) => a - b);

        return uniqueSorted;
    }


}





